import { useEffect, useState } from "react";
import { getPipelineWeightConfigByRunId } from "../services/scoringService";

const useFetchPipelineWeightConfigByRunId = ({
  setIsLoading,
  runInstanceId,
}: any) => {
  const [configData, setConfigData] = useState<any>({});

  useEffect(() => {
    if (runInstanceId && runInstanceId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getPipelineWeightConfigByRunId(runInstanceId);
          // Backend may return a single object or an array with one element
          const record = Array.isArray(result) ? result[0] : result;
          if (record) {
            setConfigData(record);
          }
        } catch (err) {
          setConfigData({});
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [runInstanceId]); // eslint-disable-line react-hooks/exhaustive-deps

  return [configData];
};

export default useFetchPipelineWeightConfigByRunId;
